import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "menu"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  t: "1702545140640",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4225",
  width: "20",
  height: "20"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M64 64h896v128H64V64z m0 768h896v128H64v-128z m0-384h896v128H64V448z",
  fill: "#bdbec3",
  "p-id": "4226"
})], -1);

const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}